<template>
    <div class="fluid">
    </div>
</template>
<script>
    export default {
        mounted() {
            const msgCrud = this.$store.getters.getMsgCrud;
            if(msgCrud) {
                this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: [{message: msgCrud}]});
                this.$store.commit("setMsgCrud", null)
            }
        }
    }
</script>